module.exports = [
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26250000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt0 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26250LS0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt0"
		],
		"groups": [
			{
				"products": [
					"34195001"
				],
				"bundle": []
			},
			{
				"products": [
					"34286002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26087000"
				],
				"bundle": []
			},
			{
				"products": [
					"27374000"
				],
				"bundle": []
			},
			{
				"products": [
					"27032001"
				],
				"bundle": []
			},
			{
				"products": [
					"27967000"
				],
				"bundle": []
			},
			{
				"products": [
					"27964000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27174001"
				],
				"bundle": []
			},
			{
				"products": [
					"27968000"
				],
				"bundle": []
			},
			{
				"products": [
					"27966000"
				],
				"bundle": []
			},
			{
				"products": [
					"26075000"
				],
				"bundle": []
			},
			{
				"products": [
					"27296002"
				],
				"bundle": []
			},
			{
				"products": [
					"27615001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"23147001"
				],
				"bundle": []
			},
			{
				"products": [
					"26224001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt2 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27473001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"26381001"
				],
				"bundle": []
			},
			{
				"products": [
					"27058000"
				],
				"bundle": []
			},
			{
				"products": [
					"26452000"
				],
				"bundle": []
			},
			{
				"products": [
					"26453000"
				],
				"bundle": []
			},
			{
				"products": [
					"27389001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt0 && operation_opt3 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"27421001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"26443000"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt1 && functionality_opt0 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"26443LS0"
				],
				"bundle": [
					"26449000",
					"26264001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27734000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27755000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29123000",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"27741000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29123000",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27663LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27704000"
				]
			},
			{
				"products": [
					"29153LS0",
					"27700000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"27698000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26064000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			},
			{
				"products": [
					"29125000",
					"27705000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt1 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"26071000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"28362000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34706000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26481000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26479LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29157LS0",
					"26481LS0",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt0 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26071000",
					"27251000",
					"27251000",
					"27699000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27750000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27738000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27759000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"27839000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			},
			{
				"products": [
					"29118000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27635000",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27635000",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27785000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27671LS0",
					"27784000"
				],
				"bundle": [
					"35600000",
					"28388000",
					"27057000"
				]
			},
			{
				"products": [
					"29150LS0",
					"27368000"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt2 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26459000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29119000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26056000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26052000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26475000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26072000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt0 && with-holder_opt1 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"26057000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26053000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26171LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt1 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"26053LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"34705000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26477000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26475LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt3 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26477LS0",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"26483000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26066000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt0 && shape_opt1 && functionality_opt7 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26067000",
					"27251000",
					"27251000",
					"27367000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt1"
		],
		"groups": [
			{
				"products": [
					"34399000"
				],
				"bundle": []
			},
			{
				"products": [
					"34283001"
				],
				"bundle": []
			},
			{
				"products": [
					"34408000"
				],
				"bundle": []
			},
			{
				"products": [
					"34631000"
				],
				"bundle": []
			},
			{
				"products": [
					"34506000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && installation-type_opt2 && operation_opt1 && control_opt2"
		],
		"groups": [
			{
				"products": [
					"34627000"
				],
				"bundle": []
			},
			{
				"products": [
					"34630000"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt3"
		],
		"groups": [
			{
				"products": [
					"27641000"
				],
				"bundle": []
			},
			{
				"products": [
					"27420001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt0 && control_opt4"
		],
		"groups": [
			{
				"products": [
					"27475001"
				],
				"bundle": []
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt4 && color_opt1"
		],
		"groups": [
			{
				"products": [
					"34713000",
					"26254LS0",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt1 && functionality_opt5"
		],
		"groups": [
			{
				"products": [
					"34714000",
					"13242000",
					"27673LS0"
				],
				"bundle": [
					"26449000",
					"26264001",
					"27055000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29123000",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29153LS0",
					"13303000"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27700000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29124000",
					"27700000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29124000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29124000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28995000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29125000",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29125000",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27699000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"27704000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27699000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27704000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29156LS0",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29156LS0",
					"27698000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26064000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			},
			{
				"products": [
					"29126000",
					"26073000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt0 && functionality_opt4 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29126000",
					"26065000",
					"27698000",
					"13303000"
				],
				"bundle": [
					"35600000",
					"26370000",
					"28364000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt0"
		],
		"groups": [
			{
				"products": [
					"29118000",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt6 && color_opt2"
		],
		"groups": [
			{
				"products": [
					"29150LS0",
					"13280001"
				],
				"bundle": [
					"35600000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt0 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29119000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29119000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt0 && with-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29120000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"28364000"
				]
			},
			{
				"products": [
					"29120000",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"28364000",
					"28990000",
					"14055000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt0"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27368000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27057000",
					"28990000",
					"14055000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27368000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt5 && color_opt2 && rail-holder_opt1"
		],
		"groups": [
			{
				"products": [
					"29151LS0",
					"27367000",
					"19952000"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"14055000",
					"28990000",
					"27057000"
				]
			},
			{
				"products": [
					"29151LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26056000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26052000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26475000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26072000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt0 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29121000",
					"26057000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26053000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			},
			{
				"products": [
					"29121000",
					"26477000",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt0"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26171LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && installation-type_opt2 && shape_opt1 && functionality_opt4 && color_opt2 && head-mounted_opt1"
		],
		"groups": [
			{
				"products": [
					"29904LS0",
					"26053LS0",
					"27367000",
					"13280001"
				],
				"bundle": [
					"35600000",
					"27074000",
					"28364000",
					"27057000"
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_conditions_tr_tr.json
// module id = 817
// module chunks = 0